import { colord } from 'colord';
import { useMemo, useState } from 'react';
import ColorWrapper from './ColorWrapper';
import { colorArrayToLinearGradient } from '../../utils';
import './style.scss';

const ColorPickerButton = ({ value, onChange, title }) => {
  const [visible, setVisible] = useState(false);

  const display = useMemo(() => {
    if (typeof value === 'string') {
      return { text: colord(value).alpha(1).toHex().toUpperCase(), bg: value };
    }
    if (Array.isArray(value)) {
      return {
        text: `${colord(value[0]).alpha(1).toHex().toUpperCase()} - ${colord(
          value[value.length - 1]
        )
          .alpha(1)
          .toHex()
          .toUpperCase()}`,
        bg: colorArrayToLinearGradient(value, 90),
      };
    }
    return {};
  }, [value]);

  return (
    <ColorWrapper
      visible={visible}
      setVisible={setVisible}
      value={value}
      onChange={onChange}
      title={title}
    >
      <div className="group-detail-style__color">
        <div className="group-detail-style__color--value">
          <div
            className="group-detail-style__color--value--box"
            style={{
              background: display.bg,
            }}
          />
          {display.text}
        </div>
      </div>
    </ColorWrapper>
  );
};

export default ColorPickerButton;
